<app-loading *ngIf="loading"></app-loading>
<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div>
            <a class="a-home" routerLink="/home">Home/</a>
        </div>
        <div>
            <a class="text-info" routerLink="/billing">Nota de Remisión</a>
        </div>
    </div>
</div>

<div class="main-content">
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">

                    <div class="row" *ngIf="stepNR === 1"> <!-- Encabezado -->
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Sucursal</label>
                                <h6>{{storeName}}</h6>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label>Fecha Emisión</label>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]="shipment.FechaEmisionNR"/>
                        </div>
                        <div class="col-md-3">
                            <label><b>Tipo de Transacción</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="shipment.TipoTransaccionShipment" placeholder="Tipo de transacción" />                            
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Cliente <span style="color: red">*</span></label>
                                <div style="color: black !important">
                                    <angular2-multiselect [data]="clientList" [(ngModel)]="selectedItemsClient"
                                        [settings]="dropdownSettingsCliente"
                                        (onSelect)="onItemSelectClient($event)">
                                    </angular2-multiselect>
                                    <!-- <input type="number" class="form-control" [(ngModel)]='price' placeholder="Precio" /> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label><b>Email Cliente</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.EmailCliente' placeholder="Email Cliente" />
                        </div>
                        <div class="col-md-3">
                            <label><b>RUC Cliente</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumDocCliente' placeholder="RUC Cliente" />
                        </div>
                    </div>

                    <hr *ngIf="stepNR === 1"/><br *ngIf="stepNR === 1">

                    <div class="row" *ngIf="stepNR === 1">
                        <div class="col-md-4">
                            <label><b>Motivo de emisión</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.MotivoEmision' placeholder="Motivo de emisión" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Responsable de la emisión</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ResponsableEmision' placeholder="Responsable de la emisión" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Km. Estimados de recorrido</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.KmEstimados' placeholder="Km. Estimados" />
                        </div>
                        <div class="col-md-4">
                            <label>Fecha Emisión Fact.</label>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]="shipment.FechaEmision" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Costo del Flete</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.CostoFlete' placeholder="Costo del Flete" />
                        </div>
                    </div>

                    <hr /><br>

                    <div class="row" *ngIf="stepNR === 1">
                        <div class="col-md-4">
                            <label><b>Observaciones del emisor</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ObservacionesEmisor' placeholder="Observaciones del emisor" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Información de interés del Fisico</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.InformacionInteresFisico' placeholder="Información de interés del Fisico" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Tipo Documento Asociado</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumOrdenCompra' placeholder="Tipo Documento Asociado"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Num. Documento Asociado</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumOrdenVenta' placeholder="Num. Documento Asociado"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Fecha Emisión Documento Asociado</b></label>
                            <input type="date" class="form-control" [(ngModel)]='shipment.NumAsientoContable' placeholder="Fecha Documento Asociado"/>
                        </div>                        
                    </div>
                    
                    <div class="col-md-12" *ngIf="stepNR === 2">
                        <h5>Mercancía</h5> <span style="color: red">*</span>
                    </div>

                    <div class="row" *ngIf="stepNR === 2">
                        <!-- <div class="col-sm-12 col-md-6">
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'" [settings]="dropdownSettings"
                                [data]="inventoryList" [(ngModel)]="selectedItems" (onSelect)="onItemSelect($event)"
                                (onDeSelect)="onItemDeSelect($event)">
                            </ng-multiselect-dropdown>
                        </div> -->
                        <div class="col-sm-12 col-md-4">
                            <label><b>Codigo Estuche</b></label>
                            <div class="form-group">
                                <input type="number" class="form-control"
                                    [(ngModel)]='transferDetail.transferInventoryDetailQuantity'
                                    placeholder="Cantidad" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <button type="submit" class="btn btn-info btn-sale" (click)="saveLine()"
                                [disabled]="isDisabled" *ngIf="!serial">Agregar Estuches</button>                            
                        </div>
                        <div class="col-sm-12 col-md-2">                            
                            <button type="submit" class="btn btn-danger btn-sale" (click)="cleanLine()"
                                [disabled]="isDisabled" *ngIf="!serial">Borrar Estuches</button>                            
                        </div>
                        <div class="col-md-12" *ngIf="serial">
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'" [settings]="dropdownSettingsSerial"
                                [data]="serialList" [(ngModel)]="selectedItemsSerial"
                                (onSelect)="onItemSelectSerial($event)" (onDeSelect)="onItemDeSelectSerial($event)">
                            </ng-multiselect-dropdown>
                            <br>
                        </div>
                    </div>                    

                    <div class="row" *ngIf="stepNR === 2">
                        <div class="col-sm-12 col-md-2">
                            <div class="form-group">
                                <input type="number" class="form-control"
                                    [(ngModel)]='transferDetail.transferInventoryDetailQuantity'
                                    placeholder="Cantidad" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <textarea class="form-control" [(ngModel)]="transferDetail.description" rows="3" placeholder="Descripcion"></textarea>
                        </div>                                              
                        <div class="col-sm-12 col-md-2">
                            <button type="submit" class="btn btn-info btn-sale" (click)="saveLineDesc()" [disabled]="isDisabled" *ngIf="!serial">Agregar Desc.</button>
                        </div>
                    </div>
                    <!-- DETAIL -->
                    <div class="col-md-12" *ngIf="stepNR === 2">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr style="font-weight: bold;">
                                        <td>No.</td>
                                        <td class="text-center">Cantidad</td>
                                        <td class="text-center">Descripción de la mercancía</td>
                                        <!-- <td class="text-center">P/U con IVA Q</td>
                                        <td class="text-center">Total Q</td> -->
                                        <td class="text-center">Opción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let e of transferLine, let i=index">
                                        <td class="text-center">{{i+1}}</td>
                                        <!-- <td class="text-center">{{e.transferInventoryDetailQuantity | number:'1.2-2'}}</td>-->
                                        <td>
                                            <input type="number" class="form-control" [(ngModel)]="e.transferInventoryDetailQuantity"                                                
                                                style="max-width: 90px; margin: 0px auto;" />
                                        </td>
                                        <!-- <td>{{e.description}}</td> -->
                                        <td>
                                            <textarea class="form-control" [(ngModel)]="e.description"
                                                style="max-width: 250px; margin: 0px auto;" rows="4"></textarea>
                                        </td>
                                        <!-- <td class="text-right">{{e.unitPrice | number:'1.2-2'}}</td>
                                        <td class="text-right">{{e.subtotal | number:'1.2-2'}}</td> -->
                                        <td class="text-center">
                                            <button class="btn btn-danger btn-sm"
                                                (click)="deleteLine(e.transferInventoryDetailInventoryCode)"
                                                [disabled]="isDisabled" ngbTooltip="Eliminar" placement="left">
                                                <i class="now-ui-icons ui-1_simple-remove"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row" *ngIf="stepNR === 3"> <!-- Información Transporte -->
                        <div class="col-md-12">
                            <h5>Información del Transporte</h5>
                        </div>
                        <div class="col-md-4">
                            <label><b>Tipo de Transporte</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.TipoTransporte' placeholder="Tipo de Transporte" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Modalidad del Transporte</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ModalidadTransporte' placeholder="Modalidad del Transporte" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Responsable del Costo del Flete</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ResponsableCostoFlete' placeholder="Responsable del Costo del Flete" />
                        </div>
                        <div class="col-md-4">
                            <label><b>Condición de la negociación</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.CondicionNegociacion' placeholder="Condición de la negociación" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Num. Manifiesto</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumManifiesto' placeholder="Num. Manifiesto" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Num. de Despacho de Importación</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumDespachoImportacion' placeholder="Num. de Despacho de Importación" disabled/>
                        </div>
                        <div class="col-md-2">
                            <label>Fecha Inicio de Traslado</label> <span style="color: red">*</span>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]='shipment.FechaInicioTraslado'/>
                        </div>
                        <div class="col-md-2">
                            <label>Fecha Fin de Traslado</label> <span style="color: red">*</span>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]='shipment.FechaFinTraslado'/>
                        </div>
                        <div class="col-md-4">
                            <label><b>País de Destino</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.PaisDestino' placeholder="País de Destino"/>
                        </div>
                    </div>

                    <div class="row" *ngIf="stepNR === 4"> <!-- Información Salida Mercaderia -->
                        <div class="col-md-12">
                            <h5>Información de Salida de Mercancía</h5>
                        </div>
                        <div class="col-md-4">
                            <label><b>Calle Principal</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.CallePrincipal' placeholder="Calle Principal"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Número de Casa de Salida</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumeroCasaSalida' placeholder="Número de Casa de Salida"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Teléfono</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.Telefono' placeholder="Teléfono"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Complemento de Dirección 1</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ComplementoDireccion1' placeholder="Complemento de Dirección 1" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Complemento de Dirección 2</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ComplementoDireccion2' placeholder="Complemento de Dirección 2" disabled/>
                        </div>
                        <div class="col-md-3 ma-g">
                            <label>Departamento <span style="color: red">*</span></label>
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'"
                                [settings]="dropdownSettingsProvincia" [data]="ProvinciaList" [(ngModel)]="selectedItemsProvincia"
                                (onSelect)="onItemSelectProvincia($event)" [disabled]='isEdit'>
                            </ng-multiselect-dropdown>                                    
                        </div>
                        <div class="col-md-3 ma-g">
                            <label>Distrito <span style="color: red">*</span></label>
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'"
                                [settings]="dropdownSettingsDistritos" [data]="DistritosList" [(ngModel)]="selectedItemsDistritos"
                                (onSelect)="onItemSelectDistrito($event)" [disabled]='isEdit'>
                            </ng-multiselect-dropdown>                                    
                        </div>
                        <div class="col-md-3 ma-g">
                            <label>Ciudad <span style="color: red">*</span></label>
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'"
                                [settings]="dropdownSettingsCorregimientos" [data]="CorregimientosList" [(ngModel)]="selectedItemsCorregimientos"
                                (onSelect)="onItemSelectCorregimiento($event)" [disabled]='isEdit'>
                            </ng-multiselect-dropdown>                                    
                        </div>
                    </div>

                    <hr /><br>

                    <div class="row" *ngIf="stepNR === 4"> <!-- DIRECCION DE CLIENTE -->
                        <div class="col-md-12">
                            <h5>Información de Dirección del Cliente</h5>
                        </div>
                        <div class="col-md-4">
                            <label><b>Calle Principal</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.CallePrincipalCliente' placeholder="Calle Principal"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Número de Casa de Salida</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumeroCasaSalidaCliente' placeholder="Número de Casa de Salida"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Teléfono</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.TelefonoCliente' placeholder="Teléfono"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Complemento de Dirección 1</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ComplementoDireccion1Cliente' placeholder="Complemento de Dirección 1" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Complemento de Dirección 2</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ComplementoDireccion2Cliente' placeholder="Complemento de Dirección 2" disabled/>
                        </div>
                        <div class="col-md-3 ma-g">
                            <label>Departamento <span style="color: red">*</span></label>
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'"
                                [settings]="dropdownSettingsProvinciaClient" [data]="ProvinciaListClient" [(ngModel)]="selectedItemsProvinciaClient"
                                (onSelect)="onItemSelectProvinciaClient($event)" [disabled]='isEdit'>
                            </ng-multiselect-dropdown>                                    
                        </div>
                        <div class="col-md-4">
                            <label><b>Código Departamento</b></label>
                            <input type="text" class="form-control" [(ngModel)]='idProvinciaClient' placeholder="Código Departamento" disabled/>
                        </div>
                        <div class="col-md-3 ma-g">
                            <label>Distrito <span style="color: red">*</span></label>
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'"
                                [settings]="dropdownSettingsDistritosClient" [data]="DistritosListClient" [(ngModel)]="selectedItemsDistritosClient"
                                (onSelect)="onItemSelectDistritoClient($event)" [disabled]='isEdit'>
                            </ng-multiselect-dropdown>                                    
                        </div>
                        <div class="col-md-4">
                            <label><b>Código Distrito</b></label>
                            <input type="text" class="form-control" [(ngModel)]='idDistritosClient' placeholder="Código Distrito" disabled/>
                        </div>
                        <div class="col-md-3 ma-g">
                            <label>Ciudad <span style="color: red">*</span></label>
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'"
                                [settings]="dropdownSettingsCorregimientosClient" [data]="CorregimientosListClient" [(ngModel)]="selectedItemsCorregimientosClient"
                                (onSelect)="onItemSelectCorregimientoClient($event)" [disabled]='isEdit'>
                            </ng-multiselect-dropdown>                                    
                        </div>
                        <div class="col-md-4">
                            <label><b>Código Ciudad</b></label>
                            <input type="text" class="form-control" [(ngModel)]='idCorregimientosClient' placeholder="Código Ciudad" disabled/>
                        </div>
                    </div>

                    <div class="row" *ngIf="stepNR === 5"> <!-- INFORMACION DEL TRANSPORTISTA Y REPRESENTANTES-->
                        <div class="col-md-12">
                            <h5>Información del Transportista y Representantes</h5>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Representante</label>
                                <div style="color: black !important">
                                    <angular2-multiselect [data]="representativeList" [(ngModel)]="selectedItemsrepresentative"
                                        [settings]="dropdownSettingsRepresentative"
                                        (onSelect)="onItemSelectRepresentative($event)">
                                    </angular2-multiselect>                                    
                                    <!-- <input type="number" class="form-control" [(ngModel)]='price' placeholder="Precio" /> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label><b>Tipo de Vehiculo</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.TipoVehiculo' placeholder="Tipo de Vehiculo"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Marca</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.Marca' placeholder="Marca"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Tipo de Identificación Vehiculo</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.TipoIdentificacionVehiculo' placeholder="Tipo de Identificación Vehiculo"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Color del Vehiculo</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.ColorVehiculo' placeholder="Color del Vehiculo"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Num. Identificación Vehiculo</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumeroIdentificacionVehiculo' placeholder="Num. Identificación Vehiculo"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Naturaleza del Transportista</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NaturalezaTransportista' placeholder="Naturaleza del Transportista"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Nombre o Razón Social</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NombreRazonEmpresa' placeholder="Nombre o Razón Social"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>RUC</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.RucEmpresa' placeholder="RUC"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Dígito Verificador</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.DigitoVerificador' placeholder="Dígito Verificador"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Nacionalidad del Transportista</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NacionalidadTransportista' placeholder="Nacionalidad del Transportista"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>No. de Documento del Chofer</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NumeroDocumentoTransportista' placeholder="No. de Documento Transportista"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Nombre y Apellido del Chofer</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NombrePilot' placeholder="Nombre y Apellido del Chofer"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Domicilio Fiscal del Transportista</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.DomicilioFiscalTransportista' placeholder="Domicilio Fiscal del Transportista"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Dirección del Chofer</b> <span style="color: red">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.DireccionChofer' placeholder="Dirección del Chofer"/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Nombre o Razón del agente</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.NombreAgente' placeholder="Nombre o Razón del agente" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>RUC del Agente</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.RucAgente' placeholder="RUC del Agente" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Dígito Verificador del Agente</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.DigitoVerificadorAgente' placeholder="Dígito Verificador del Agente" disabled/>
                        </div>
                        <div class="col-md-4">
                            <label><b>Dirección de Agente</b></label>
                            <input type="text" class="form-control" [(ngModel)]='shipment.DireccionAgente' placeholder="Dirección de Agente" disabled/>
                        </div>
                        <div class="col-md-12" style="text-align: end;">
                            <button class="btn btn-success btn-beg" (click)="save()" [disabled]="isDisabled">
                                ✔ Generar Envío
                            </button>                            
                        </div>
                    </div>               

                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                            <button class="btn btn-secondary mr-2" (click)="goBack()" [disabled]="stepNR === 1">Atrás</button>
                            <button class="btn btn-primary" (click)="goNext()" [disabled]="stepNR === 5">Adelante</button>
                        </div>
                    </div>

                    <!-- <div class="row">
                        <div class="col-md-4" style="text-align: end;">
                            <button class="btn btn-success btn-beg" (click)="save()" [disabled]="isDisabled">
                                ✔ Generar Envío
                            </button>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>Sucursal</label>
                                <h6>{{storeName}}</h6>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label><b>Tipo Envío</b></label>
                            <angular2-multiselect [data]="transferTypeList" [(ngModel)]="selectedItemstransferType"
                                [settings]="dropdownSettingstransferType" (onSelect)="onItemSelectTransferType($event)" (onDeSelect)="onDeSelectTransferType()">
                            </angular2-multiselect>
                        </div>
                        <div class="col-md-2" *ngIf="RefNotaSalida">
                            <label><b>Nota de Salida Ref.</b></label>
                            <input type="number" class="form-control" [(ngModel)]='transferDetail.transferNotaSalida' />
                        </div>
                        <div class="col-md-4" *ngIf="RefNotaSalida">
                            <label><b>Sucursal de Envío</b></label>
                            <angular2-multiselect [data]="storeList" [(ngModel)]="selectedItemsStore"
                                [settings]="dropdownSettingsStores" (onSelect)="onItemSelectStore($event)" (onSelectAll)="onSelectAllStore()"
                                (onDeSelect)="onDeItemSelectStore($event)" (onDeSelectAll)="onDeSelectAllStore()">
                            </angular2-multiselect>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Destino</label>
                                <div style="color: black !important">
                                    <angular2-multiselect [data]="warehouseList" [(ngModel)]="selectedItemsWarehouse"
                                        [settings]="dropdownSettingsWarehouse"
                                        (onSelect)="onItemSelectWarehouse($event)">
                                    </angular2-multiselect>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <hr>
                    <h6>Datos del Conductor</h6>
                    <div class="row">                        
                        <br>
                        <div class="col-md-3">
                            <label><b>Nombre del Cliente</b></label>
                            <input type="text" class="form-control" [(ngModel)]='NombrePilot' placeholder="Nombre" />
                        </div>
                        <div class="col-md-3">
                            <label><b>DPI Conductor</b></label>
                            <input type="text" class="form-control" [(ngModel)]='DPIPilot' />
                        </div>
                        <div class="col-md-3">
                            <label><b>Teléfono Conductor</b></label>
                            <input type="text" class="form-control" [(ngModel)]='TelPilot' />
                        </div>
                        <div class="col-md-3">
                            <label><b>Dirección Envio</b></label>
                            <input type="text" class="form-control" [(ngModel)]='DirPilot' />
                        </div>
                    </div>
                    <hr>
                    <h6>Datos del Vehiculo</h6>
                    <div class="row">                        
                        <br>
                        <div class="col-md-3">
                            <label><b>Marca</b></label>
                            <input type="text" class="form-control" [(ngModel)]='MarcaCarro' />
                        </div>
                        <div class="col-md-3">
                            <label><b>Placa</b></label>
                            <input type="text" class="form-control" [(ngModel)]='PlacaCarro' />
                        </div>
                        <div class="col-md-3">
                            <label><b>Modelo</b></label>
                            <input type="text" class="form-control" [(ngModel)]='ModeloCarro' />
                        </div>
                        <div class="col-md-3">
                            <label><b>Color</b></label>
                            <input type="text" class="form-control" [(ngModel)]='ColorCarro' />
                        </div>
                    </div>
                    <hr>
                    <br>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Motivo de Envío</label>
                                <select class="form-control form-control-sm" [ngModel]="transferHeader.transferRazon" (ngModelChange)="onChangeRazonTransfer($event)">
                                    <option value=1>Prestamo</option>
                                    <option value=2>Venta</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <textarea class="form-control" rows="4" placeholder="OBSERVACIONES..." [(ngModel)]="transferHeader.transOtherRazonDesc"></textarea>
                        </div>
                    </div>
                    <br>
                    <div class="row" *ngIf="companyAddDescription == 1">
                        <div class="col-sm-12 col-md-8">
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'" [settings]="dropdownSettings"
                                [data]="inventoryList" [(ngModel)]="selectedItems" (onSelect)="onItemSelect($event)"
                                (onDeSelect)="onItemDeSelect($event)">
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <div class="form-group">
                                <input type="number" class="form-control"
                                    [(ngModel)]='transferDetail.transferInventoryDetailQuantity'
                                    placeholder="Cantidad" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <button type="submit" class="btn btn-info btn-sale" (click)="saveLine()"
                                [disabled]="isDisabled" *ngIf="!serial">Agregar</button>
                            <button type="submit" class="btn btn-info btn-sale" (click)="saveLineSerial()"
                                [disabled]="isDisabled" *ngIf="serial">Agregar</button>
                        </div>
                        <div class="col-md-12" *ngIf="serial">
                            <ng-multiselect-dropdown [placeholder]="'Seleccione...'" [settings]="dropdownSettingsSerial"
                                [data]="serialList" [(ngModel)]="selectedItemsSerial"
                                (onSelect)="onItemSelectSerial($event)" (onDeSelect)="onItemDeSelectSerial($event)">
                            </ng-multiselect-dropdown>
                            <br>
                        </div>
                    </div>

                    <div class="row" *ngIf="companyAddDescription == 0">
                        <div class="col-sm-12 col-md-2">
                            <div class="form-group">
                                <input type="number" class="form-control"
                                    [(ngModel)]='transferDetail.transferInventoryDetailQuantity'
                                    placeholder="Cantidad" />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-8">
                            <textarea class="form-control" [(ngModel)]="transferDetail.description" rows="3" placeholder="Descripcion"></textarea>
                        </div>                        
                        <div class="col-sm-12 col-md-2">
                            <button type="submit" class="btn btn-info btn-sale" (click)="saveLineDesc()" [disabled]="isDisabled" *ngIf="!serial">Agregar</button>                            
                        </div>
                    </div> -->
                    <!-- DETAIL -->
                    <!-- <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr style="font-weight: bold;">
                                        <td>No.</td>
                                        <td>Cantidad</td>
                                        <td>Descripción de la mercancía</td>
                                        <td class="text-center">Opción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let e of transferLine, let i=index">
                                        <td class="text-center">{{i+1}}</td>
                                        <td class="text-center">{{e.transferInventoryDetailQuantity | number:'1.2-2'}}
                                        </td>
                                        <td>{{e.description}}</td>
                                        <td class="text-center">
                                            <button class="btn btn-danger btn-sm"
                                                (click)="deleteLine(e.transferInventoryDetailInventoryCode)"
                                                [disabled]="isDisabled" ngbTooltip="Eliminar" placement="left">
                                                <i class="now-ui-icons ui-1_simple-remove"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> -->
                    <div class="row">
                        <!-- <div class="col-md-12"
                            style="text-align: end; font-weight: bold; font-size: 25px; padding-right: 35px;">
                            Total <small style="font-weight: bold; font-size: 20px;">Q</small>
                            {{total | number:'1.2-2'}}
                        </div> -->
                    </div>
                </div>
                <!-- END DETAIL -->
            </div>
        </div>
    </div>
</div>
